import './S_WorkspaceOwnerIcon.scss';
import { faShareAlt, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
interface Props {
  isMine: boolean;
  notOwnerTitle: string;
}

export const S_WorkspaceOwnerIcon = ({ isMine: isMy, notOwnerTitle }: Props): ReactElement => {
  const { t } = useTranslator();
  return (
    <div className='workspace-owner-icon-container'>
      {isMy && (
        <FontAwesomeIcon
          className='my-workspace'
          icon={faUser}
          title={t('workspace_owner_icon.you_are_the_owner')}
        />
      )}
      {!isMy && (
        <FontAwesomeIcon
          className='not-my-workspace'
          icon={faShareAlt}
          title={notOwnerTitle}
        />
      )}
    </div>
  );
};
